/**
 * Anti-abuse bounds shared across the public RDV surface (#622). Real,
 * ANTI-ABUSE only — NOT business format validation (phone/SIRET syntax stays
 * out of scope). The bounds are far above any legitimate value: without them,
 * an oversized string reaches the mysql2 driver and blows up as a raw 500
 * instead of the clean Zod 400 the controller doctrine promises (F4).
 *
 * Centralized: the four public payload schemas (`matchEmail`, `proposals`,
 * `request`, `publicGeocode`) all import the same constants so DB column
 * resizes propagate in one place. See CLAUDE.md — shared types SoT.
 */
/** RFC 5321 practical ceiling — an email address longer than this can never route. */
export const PUBLIC_API_EMAIL_MAX = 254;
/** `varchar(255)` safety net for our own columns and the ORM's error surface. */
export const PUBLIC_API_SHORT_STRING_MAX = 255;
/** Roomy vs any real postal address; still bounded. */
export const PUBLIC_API_ADDRESS_MAX = 500;
/** A public booking basket carries a handful of services, never thousands. */
export const PUBLIC_API_SERVICE_IDS_MAX = 20;
/**
 * "YYYY-MM-DDTHH:mm:ss" is 19 chars — this leaves 6 chars headroom before the
 * refine runs its component parse. Belt-and-suspenders: the refine's regex is
 * already length-strict, this is a cheap cost-of-parse guard.
 */
export const PUBLIC_API_REQUESTED_START_AT_MAX = 25;
//# sourceMappingURL=bounds.js.map